/* GearFrost <gf-cart-countdown> — "your cart is reserved" urgency timer for the cart drawer/page.
 * The end time is anchored in sessionStorage so it stays consistent across page navigation within a
 * session; the timer runs while the cart has items, driven by the cart-update pub/sub (Dawn re-renders
 * the cart on change, but the timer relies on the event + sessionStorage, not the server markup). */
if (!customElements.get('gf-cart-countdown')) {
  customElements.define(
    'gf-cart-countdown',
    class GfCartCountdown extends HTMLElement {
      connectedCallback() {
        this.timeEl = this.querySelector('[data-countdown-time]');
        this.minutes = parseInt(this.dataset.minutes, 10) || 5;
        this.duration = this.minutes * 60 * 1000;
        this.key = 'gf_cart_endtime';

        if ((parseInt(this.dataset.cartcount, 10) || 0) > 0) {
          this.startTimer();
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.onCartUpdate());
        }
      }

      disconnectedCallback() {
        this.stopTimer();
        if (this.unsubscribe) this.unsubscribe();
      }

      onCartUpdate() {
        const base = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${base}.js`, { headers: { Accept: 'application/json' } })
          .then((res) => res.json())
          .then((cart) => {
            if ((cart.item_count || 0) > 0) this.startTimer();
            else this.reset();
          })
          .catch(() => {});
      }

      // Returns the (possibly refreshed) end time; loops by resetting once the previous one elapses.
      getEndTime() {
        const now = Date.now();
        let end;
        try {
          end = parseInt(sessionStorage.getItem(this.key), 10);
        } catch (e) {
          // Some browsers throw on sessionStorage access when storage/cookies are blocked.
          end = NaN;
        }
        if (!end || end <= now) {
          end = now + this.duration;
          try {
            sessionStorage.setItem(this.key, String(end));
          } catch (e) {
            /* private mode / storage disabled — timer still ticks for this page */
          }
        }
        return end;
      }

      startTimer() {
        this.hidden = false;
        if (this.timer) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      tick() {
        const remaining = Math.max(0, this.getEndTime() - Date.now());
        const totalSec = Math.floor(remaining / 1000);
        const m = Math.floor(totalSec / 60);
        const s = totalSec % 60;
        if (this.timeEl) {
          this.timeEl.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        }
      }

      stopTimer() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      reset() {
        this.stopTimer();
        try {
          sessionStorage.removeItem(this.key);
        } catch (e) {
          /* ignore */
        }
        this.hidden = true;
      }
    }
  );
}
